import React, { FC, useEffect, useRef, useState } from 'react';
import { ToggleComponent } from 'src/common/form/toggle/component';
import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { ControlPanelShell } from '../components/control-panel/shell';
import uniqueId from 'lodash/uniqueId';
import { useClickAway } from 'react-use';
import { easings, useSpring, useSpringRef, animated } from '@react-spring/web';
import classNames from 'classnames';
import { apiUpdateJourneyAlias } from 'src/utils/journeyApi';
import { Journey } from 'src/common/interfaces/journey.interface';
import { EventBus } from 'src/common/EventBus';

interface NeuePlayerIndexingPanelProps extends Pick<JourneyMenuPropsInterface, 'openRef' | 'closeRef'> {
  isEnabled: boolean;
  uuid: Journey['uuid'];
}

const FLOAT_ANIMATION_CONFIG = {
  mass: 1,
  tension: 400,
  friction: 40,
};

export const NeuePlayerIndexingPanel: FC<NeuePlayerIndexingPanelProps> = ({ uuid, openRef, closeRef, isEnabled }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isToggleEnabled, setIsToggleEnabled] = useState(!!isEnabled);
  const [shellKey, setShellKey] = useState(uniqueId());
  const [isOpen, setIsOpen] = useState(false);

  // useEffect(() => {
  //   if (!isEnabled) {
  //     apiUpdateJourneyAlias(uuid, { disable_indexing: true });
  //     EventBus.emit('neue-player:change-indexing', true);
  //   }
  // }, []);

  useClickAway(ref, () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  const api = useSpringRef();
  const [styles] = useSpring(
    () => ({
      ref: api,
      from: { y: 8, opacity: 0 },
      to: { y: 0, opacity: 1 },
    }),
    []
  );

  useEffect(() => {
    if (isOpen) {
      api.start({ from: { y: 8, opacity: 0 }, to: { y: 0, opacity: 1 }, config: FLOAT_ANIMATION_CONFIG });
    } else {
      api.start({
        opacity: 0,
        config: { duration: 200, easing: easings.easeOutCubic },
      });
    }
  }, [isOpen]);

  useEffect(() => {
    openRef.current = () => {
      setIsOpen(true);
    };

    closeRef.current = () => {
      setIsOpen(false);
    };
  }, []);

  const onIndexingChanged = async (value: boolean) => {
    await apiUpdateJourneyAlias(uuid, { disable_indexing: !value });
    setIsToggleEnabled(value);
    EventBus.emit('neue-player:change-indexing', !value);
  };

  return (
    <div ref={ref} className='relative'>
      <div
        className={classNames('absolute top-full mt-2 right-0 pointer-events-none', {
          'z-neue-share-panel-selected': isOpen,
          'z-neue-share-panel-unselected': !isOpen,
        })}
      >
        <animated.div style={styles}>
          <ControlPanelShell title='Google indexing' key={shellKey} containerClassName='!w-[16.5rem]' active={isOpen}>
            <ToggleComponent
              checked={isToggleEnabled}
              labelClassName='text-neue-journey-fg'
              onChange={onIndexingChanged}
              label='Enable indexing'
              isNeue={true}
            />
          </ControlPanelShell>
        </animated.div>
      </div>
    </div>
  );
};
